/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeTable } from '@mairistem/liste';

import { EllipsisText } from '@/components/Common';

import { formatDateHeureListe, formatNumeroActeListe } from '@/utils';

interface ActeReconnaissanceListeTableRowProps {
  item: any;
  selected?: boolean;
  /** Réduit la ligne à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeReconnaissanceListeTableRow = (
  props: ActeReconnaissanceListeTableRowProps,
) => {
  const { item, selected, sidebar } = props;

  if (!item) return null;

  const annee = item?.annee;
  const numeroRegistre = item?.numero_registre;
  const libelleRegistre = item?.libelle_registre;
  const libelleTypeActe = item?.libelle_type_acte;
  const dateActe = item?.date_acte;
  const heureActe = item?.heure_acte;
  const minuteActe = item?.minute_acte;
  const nomClassementEnfant = item?.nom_classement;
  const nomClassementEnfantAvantReconnaissance =
    item?.nom_classement_avant_reconnaissance;
  const nomClassementPere = item?.nom_classement_pere;
  const nomClassementMere = item?.nom_classement_mere;

  const registre =
    annee || numeroRegistre || libelleRegistre
      ? `${annee ?? '-'} - ${numeroRegistre ?? '-'} - ${
          libelleRegistre ? libelleRegistre.toUpperCase() : '-'
        }`
      : '-';

  const acte = formatNumeroActeListe(item);

  const dresse = formatDateHeureListe(dateActe, heureActe, minuteActe);

  if (sidebar) {
    return (
      <ListeTable.Row key={item.identifiant ?? item?.id} selected={selected}>
        <ListeTable.Cell name="nom">
          <EllipsisText text={nomClassementEnfant || 'Non renseigné'} />
        </ListeTable.Cell>
      </ListeTable.Row>
    );
  }

  return (
    <ListeTable.Row key={item.identifiant ?? item?.id} selected={selected}>
      <ListeTable.Cell name="registre">
        <EllipsisText text={registre} />
      </ListeTable.Cell>
      <ListeTable.Cell name="typeActe">
        <EllipsisText text={libelleTypeActe || '-'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="numero">
        <EllipsisText text={acte} />
      </ListeTable.Cell>
      <ListeTable.Cell name="dresse">
        <EllipsisText text={dresse} />
      </ListeTable.Cell>
      <ListeTable.Cell name="enfantAvantReconnaissance">
        <EllipsisText
          text={nomClassementEnfantAvantReconnaissance || 'Non renseigné'}
        />
      </ListeTable.Cell>
      <ListeTable.Cell name="enfant">
        <EllipsisText text={nomClassementEnfant || 'Non renseigné'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="parent1">
        <EllipsisText text={nomClassementPere || 'Non renseigné'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="parent2">
        <EllipsisText text={nomClassementMere || 'Non renseigné'} />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ActeReconnaissanceListeTableRow;
